module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/new/jamal_text-661c64d1bf8435d687211ec78d844c5b.png";